import styled from '@emotion/styled';

export default styled('div')`
  display: flex;
  align-items: center;
  margin-left: 8px;
`;
